class FaqtemplateController {
  constructor($timeout, $rootScope, $state, laboxSSapi, analyticsService) {
    this.name = 'Quick Tips';
    this.$state = $state;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.faqcontent = [];
    this.faqtemplateLoader = true;
    this.faqtemplatecontentLoader = true;
    this.isCablevision = this.$rootScope.isCablevision;
    this.isSuddenlink = this.$rootScope.isSuddenlink;
    this.selectedIndex = this.$rootScope.selectedIndex;
    console.log("index is " + this.$rootScope.selectedIndex);

    this.keyWatch = (event) => {
      window.addEventListener('keydown', this.keydown,false);
    };
    this.keydown = (event)=> {
      if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461){
        window.removeEventListener('keydown', this.keydown);
        console.log("you clicked!");
        this.$rootScope.selectedIndex = this.selectedIndex;
        this.$state.go('home.faq');
      }
    };

    if (this.isCablevision == true) {
      laboxSSapi.getOptFaq().then((res) => {
        const faqOpt = [];
        const groups = _.groupBy(res.data.labox_faq.quick_tips, subgroup => subgroup.position_id);
        for (const key in groups) {
          faqOpt.push({
            layout: groups[key][0].template_name,
            title: groups[key][0].title,
            sub_summary: groups[key][0].footer_text,
            summary: groups[key][0].summary_desc,
            main_content: groups[key][0].main_content,
            summary_image: groups[key][0].summary_image,
            image: groups[key][0].primary_image,
            sub_title: groups[key][0].sub_title
          });
          this.faqcontent = faqOpt;
          this.$timeout(() => {
            this.templateLayout = this.faqcontent[this.selectedIndex].layout;
          }, 200);

          this.faqtemplateLoader = false;
        }
        // omniture when faq template loaded successfully
          console.log('!!omniture when faq template!!');
          analyticsService.sendReport('quick tips', 'quick tips template', null, null, null, this.faqcontent[this.selectedIndex].title, null, null, 
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);
      }, (reserr)=> {
        console.log('fail ---> ', reserr);

        // omniture when faq template loaded with error
          console.log('!!omniture when faq template!!');
          analyticsService.sendReport('quick tips', 'quick tips template', null, 'api error', null, this.faqcontent[this.selectedIndex].title, null, null, 
            this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

        this.$rootScope.fromFaqPage = true;
        this.$state.go('home.landingpage');
      });
    } else if (this.isSuddenlink == true) {
      laboxSSapi.getSdlFaq().then((res) => {
        const faqSdl = [];
        const groups = _.groupBy(res.data.labox_faq.quick_tips, subgroup => subgroup.position_id);
        for (const key in groups) {
          faqSdl.push({
            layout: groups[key][0].template_name,
            title: groups[key][0].title,
            sub_summary: groups[key][0].footer_text,
            summary: groups[key][0].summary_desc,
            main_content: groups[key][0].main_content,
            summary_image: groups[key][0].summary_image,
            image: groups[key][0].primary_image,
            sub_title: groups[key][0].sub_title
          });
          this.faqcontent = faqSdl;
          this.$timeout(() => {
            this.templateLayout = this.faqcontent[this.selectedIndex].layout;
          }, 200);
          this.faqtemplateLoader = false;
        }
      }, (reserr)=> {
        console.log('fail ---> ', reserr);
        this.$rootScope.fromFaqPage = true;
        this.$state.go('home.landingpage');
      });
    }
    this.$timeout(() => {
      // this.templateLayout = this.faqcontent[this.selectedIndex].layout;
      console.log('this.templateLayout ' + this.templateLayout);

      // setting summary
      if (this.faqcontent[this.selectedIndex].main_content === null) {
        console.log('nothing here');
      } else {
        console.log('this.faqcontent[this.selectedIndex].main_content ' + this.faqcontent[this.selectedIndex].main_content);
        console.log('document.getElementsByClassName(faq_summary)[0] ' + document.getElementsByClassName('faq_summary')[0]);
        document.getElementsByClassName('faq_summary')[0].innerHTML = this.faqcontent[this.selectedIndex].main_content;
      }

      // setting sub summary
      if (this.faqcontent[this.selectedIndex].sub_summary === null) {
        console.log('nothing here');
      } else {
        console.log('this.faqcontent[this.selectedIndex].sub_summary ' + this.faqcontent[this.selectedIndex].sub_summary);
        console.log('document.getElementsByClassName(faq_subsummary)[0] ' + document.getElementsByClassName('faq_subsummary')[0]);
        document.getElementsByClassName('faq_subsummary')[0].innerHTML = this.faqcontent[this.selectedIndex].sub_summary;
      }
      this.faqtemplatecontentLoader = false;
    }, 600);
  }
}

FaqtemplateController.$inject = ['$timeout', '$rootScope', '$state', 'laboxSSapi', 'analyticsService'];

export default FaqtemplateController;



// WEBPACK FOOTER //
// ./client/app/components/faqtemplate/faqtemplate.controller.js